module.exports = __webpack_public_path__ + "media/images/featured_quote_member-36d4434f4df794edb628d0545faf3d2f.jpg";